import * as cookie from 'cookie';

const isDocument = () => typeof document === 'object';

const oneYear = 60 * 60 * 24 * 365;

export const documentGetCookie = (name) =>
  isDocument() ? cookie.parse(document.cookie)[name] : null;

export const documentSetCookie = (name, value, path = '/', expires = oneYear) => {
  if (isDocument()) {
    document.cookie = cookie.serialize(name, value, { maxAge: expires, path });
  }
};

export const deleteCookie = (name) => {
  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
};

export const stringGetCookie = (name, cookieStr) =>
  cookieStr ? cookie.parse(cookieStr)[name] : null;
